import TooltipIcon from "@/v2-ui/tooltip/TooltipIcon"
import type { PrivacyField } from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.types"

export type TenantPrivacyFieldHeaderProps = {
  field: PrivacyField
}

// The header of one person-field column. Same markup the shared Table gives
// a described column (label + info icon), wrapped in the Select trigger's
// own box — a 1px border and px-2 — so the label starts exactly above the
// dot in the cells below instead of 9px to its left. A field the person
// procedures do not enforce yet shows a full-strength lock instead of the
// dimmed info icon: its cells render disabled, and without a persistent cue
// the column would read the same as "disabled while saving".
function TenantPrivacyFieldHeader(props: TenantPrivacyFieldHeaderProps) {
  const { field } = props

  const isLocked = !field.IsEnforced

  return (
    <span className="ui-table-header-label border border-transparent px-2">
      {field.Name ?? field.ColumnName}
      {(isLocked || field.Description) && (
        <TooltipIcon
          iconSrc={isLocked ? "lock" : "info"}
          iconSize={12}
          iconClassName={
            isLocked ? "shrink-0 cursor-help" : "ui-table-header-tooltip-icon"
          }
          content={
            field.Description && (
              <span className="block px-3 py-2">{field.Description}</span>
            )
          }
          contentSide="top"
          contentClassName="ui-tooltip-content--panel max-w-[280px]"
        />
      )}
    </span>
  )
}

export default TenantPrivacyFieldHeader
